import { DependencyList, useCallback, useState } from 'react';

/**
 * A custom hook for setting a simple state _and_ running a callback. The initial state
 * value is always `null`.
 */
export function useStateWithEffect<P>(
  onChange: (value: P | null) => void,
  dependencies: DependencyList
): [P | null, (value: P | null) => void] {
  const [state, innerSetState] = useState<P | null>(null);
  const setState = useCallback(
    (value: P | null) => {
      innerSetState(value);
      onChange(value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies
  );
  return [state, setState];
}
